import { render } from "./Pediatrics.vue?vue&type=template&id=8b692adc&scoped=true"
import script from "./Pediatrics.vue?vue&type=script&lang=ts"
export * from "./Pediatrics.vue?vue&type=script&lang=ts"

import "./Pediatrics.vue?vue&type=style&index=0&id=8b692adc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8b692adc"

export default script